import { Typography } from 'antd';
import React from 'react';

type CodeNotFoundProps = {
  status?: '404';
};

const CodeNotFound: React.FC<CodeNotFoundProps> = ({ status }) => (
  <div className="p-codeNotFound">
    {status === '404' ? (
      <Typography.Title level={2}>
        Chương trình không tìm thấy
      </Typography.Title>
    ) : (
      <Typography.Title level={2}>
        Đường dẫn không hợp lệ,
        <br />
        {' '}
        xin vui lòng thử lại!
      </Typography.Title>
    )}
  </div>
);

export default CodeNotFound;
